import { render, staticRenderFns } from "./SpecialProduct.vue?vue&type=template&id=68646f54&scoped=true&"
import script from "./SpecialProduct.vue?vue&type=script&lang=js&"
export * from "./SpecialProduct.vue?vue&type=script&lang=js&"
import style0 from "./SpecialProduct.vue?vue&type=style&index=0&id=68646f54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68646f54",
  null
  
)

export default component.exports